<template>
    <div>
        <breadcrumb :routerList="[{to:'/establish/flXsjlTarget',title:'目标导入详情'},{title:'返利目标审核'}]"/>
        <div class="h-piece" style="margin:20px">
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>返利目标审核</h1>
                </div>
                <div class="h-formLine daoruhetong">
                    <el-form ref="f" :model="f" label-position="right"
                    :inline="true"  class="demo-ruleForm h-formbLine">

                    <el-form-item label="经销商名称" class="h-elformWrap-2">
                    <el-input v-model="f.agentName" :v="f.agentName" style="width:3.2rem" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="经销商编码"   class="h-elformWrap-2">
                    <el-input v-model="f.agentCode" :v="f.agentCode" style="width:3.2rem" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="经销商类型" class="h-elformWrap-2">
                        {{f.agentType | dictname('fl_agent_type')}}
                    </el-form-item>
                    <el-form-item label="年"  class="h-elformWrap-2">
                    <el-input v-model="f.year" :v="f.year" style="width:3.2rem" readonly></el-input>
                    </el-form-item>
                        <el-form-item label="区域"  class="h-elformWrap-2">
                            <el-input v-model="f.area" :v="f.area" style="width:3.2rem" readonly></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="h-formLine ">
                    <!--展示表格-->
                    <div class="h-table h-mrt30 sjwstyle">
                        <el-table
                                  ref="ddtable"
                                  :data="tableData"
                                  stripe
                                  style="width: 100%"
                        >
                            <el-table-column
                                    type="index"
                                    label="#"
                                    fixed
                                    width="40">
                            </el-table-column>
                            <el-table-column
                                    prop="planStatus"
                                    label="审核状态"
									:show-overflow-tooltip="true"
                                    width="90">
                                <template slot-scope="scope">
                                  {{scope.row.planStatus|dictname('fl_goal_approve_status')}}
                                </template>
                            </el-table-column>
                             <el-table-column
                                    prop="salesRegionCode"
                                    label="渠道"
									:show-overflow-tooltip="true"
                                    width="90">
                                <template slot-scope="scope">
                                    {{scope.row.salesRegionCode|dictname('fl_sales_region_qudao')}}
                                </template>
                            </el-table-column>
                          <el-table-column
                              prop="belongIndustry"
                              label="返利归属产业"
                              :show-overflow-tooltip="true"
                              width="100">
                            <template slot-scope="scope">
                              {{scope.row.belongIndustry|dictname('fl_belong_industry')}}
                            </template>
                          </el-table-column>
                          <el-table-column
                              prop="rebateChainGroup"
                              label="签约链群"
                              :show-overflow-tooltip="true"
                              width="90">
                            <template slot-scope="scope">
                              {{scope.row.rebateChainGroup|dictname('rebate_chain_group')}}
                            </template>
                          </el-table-column>
                            <el-table-column
                                    prop="qunianTongqi"
                                    label="去年同期(万元)"
									:show-overflow-tooltip="true"
                                    width="90">
										<template slot-scope="scope">
											<div style="text-align: right;">{{scope.row.qunianTongqi/10000}}</div>
										</template>
                            </el-table-column>
                            <el-table-column
                                    prop="jinnianGoal"
                                    label="今年目标(万元)"
									:show-overflow-tooltip="true"
                                    width="90">
										<template slot-scope="scope">
											<div style="text-align: right;">{{scope.row.jinnianGoal/10000}}</div>
										</template>
                            </el-table-column>
                            <el-table-column label="1月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume1"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="one" style="text-align: right;color: red">{{scope.row.salesVolume1/10000}}</div>
												<div v-if="!one" style="text-align: right;">{{scope.row.salesVolume1/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal1"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="one" style="text-align: right;color: red">{{scope.row.goal1/10000}}</div>
												<div v-if="!one" style="text-align: right;">{{scope.row.goal1/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="2月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume2"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="one" style="text-align: right;color: red">{{scope.row.salesVolume2/10000}}</div>
												<div v-if="!one" style="text-align: right;">{{scope.row.salesVolume2/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal2"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="one" style="text-align: right;color: red">{{scope.row.goal2/10000}}</div>
												<div v-if="!one" style="text-align: right;">{{scope.row.goal2/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="3月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume3"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="one" style="text-align: right;color: red">{{scope.row.salesVolume3/10000}}</div>
												<div v-if="!one" style="text-align: right;">{{scope.row.salesVolume3/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal3"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="one" style="text-align: right;color: red">{{scope.row.goal3/10000}}</div>
												<div v-if="!one" style="text-align: right;">{{scope.row.goal3/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="4月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume4"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="two" style="text-align: right;color: red">{{scope.row.salesVolume4/10000}}</div>
												<div v-if="!two" style="text-align: right;">{{scope.row.salesVolume4/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal4"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="two" style="text-align: right;color: red">{{scope.row.goal4/10000}}</div>
												<div v-if="!two" style="text-align: right;">{{scope.row.goal4/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="5月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume5"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="two" style="text-align: right;color: red">{{scope.row.salesVolume5/10000}}</div>
												<div v-if="!two" style="text-align: right;">{{scope.row.salesVolume5/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal5"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="two" style="text-align: right;color: red">{{scope.row.goal5/10000}}</div>
												<div v-if="!two" style="text-align: right;">{{scope.row.goal5/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="6月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume6"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="two" style="text-align: right;color: red">{{scope.row.salesVolume6/10000}}</div>
												<div v-if="!two" style="text-align: right;">{{scope.row.salesVolume6/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal6"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="two" style="text-align: right;color: red">{{scope.row.goal6/10000}}</div>
												<div v-if="!two" style="text-align: right;">{{scope.row.goal6/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="7月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume7"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="three" style="text-align: right;color: red">{{scope.row.salesVolume7/10000}}</div>
												<div v-if="!three" style="text-align: right;">{{scope.row.salesVolume7/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal7"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="three" style="text-align: right;color: red">{{scope.row.goal7/10000}}</div>
												<div v-if="!three" style="text-align: right;">{{scope.row.goal7/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="8月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume8"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="three" style="text-align: right;color: red">{{scope.row.salesVolume8/10000}}</div>
												<div v-if="!three" style="text-align: right;">{{scope.row.salesVolume8/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal8"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="90">
											<template slot-scope="scope">
                                                <div v-if="three" style="text-align: right;color: red">{{scope.row.goal8/10000}}</div>
												<div v-if="!three" style="text-align: right;">{{scope.row.goal8/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="9月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume9"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="three" style="text-align: right;color: red">{{scope.row.salesVolume9/10000}}</div>
												<div v-if="!three" style="text-align: right;">{{scope.row.salesVolume9/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal9"
										:show-overflow-tooltip="true"
                                        label="目标(万元)"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="three" style="text-align: right;color: red">{{scope.row.goal9/10000}}</div>
												<div v-if="!three" style="text-align: right;">{{scope.row.goal9/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="10月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume10"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="four" style="text-align: right;color: red">{{scope.row.salesVolume10/10000}}</div>
												<div v-if="!four" style="text-align: right;">{{scope.row.salesVolume10/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal10"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="four" style="text-align: right;color: red">{{scope.row.goal10/10000}}</div>
												<div v-if="!four" style="text-align: right;">{{scope.row.goal10/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="11月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume11"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="four" style="text-align: right;color: red">{{scope.row.salesVolume11/10000}}</div>
												<div v-if="!four" style="text-align: right;">{{scope.row.salesVolume11/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal11"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="four" style="text-align: right;color: red">{{scope.row.goal11/10000}}</div>
												<div v-if="!four" style="text-align: right;">{{scope.row.goal11/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="12月" :show-overflow-tooltip="true">
                                <el-table-column
                                        prop="salesVolume12"
                                        label="同期(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="four" style="text-align: right;color: red">{{scope.row.salesVolume12/10000}}</div>
												<div v-if="!four" style="text-align: right;">{{scope.row.salesVolume12/10000}}</div>
											</template>
                                </el-table-column>
                                <el-table-column
                                        prop="goal12"
                                        label="目标(万元)"
										:show-overflow-tooltip="true"
                                        width="100">
											<template slot-scope="scope">
                                                <div v-if="four" style="text-align: right;color: red">{{scope.row.goal12/10000}}</div>
												<div v-if="!four" style="text-align: right;">{{scope.row.goal12/10000}}</div>
											</template>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                    </div>


                </div>
            </div>
		</div>
		<div class="h-piece" style="margin:20px;padding: 0 0.26rem;">
            <div v-if="zstype" class="h-rowBox" style="margin-top:30px;">
                <div class="h-rowCon">
                    <div class="h-pieceIn2">
						<div class="h-pieceTitle2" style="margin-left:10px;margin-bottom: 0.1rem;">
						    <h1>审批意见</h1>
						</div>
                        <div  class="h-table h-mrt30 h-rowBox gggg" style="margin-top: 0.2rem;">
                            <div class="h-pieceTitle2">
                                <el-form :model="formLabelAlign" label-position="right" :inline="true"
                                         class="demo-ruleForm h-formbLine inputO">
                                    <el-form-item label="审批意见" class="h-elformWrap-2 " :required="flaag"
                                                  style="margin:0.2rem 0 0 0.2rem">
                                        <el-input v-model="formLabelAlign.checkMsg" placeholder="请输入"
                                                  class="zidaoO"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
		</div>
            <div class="h-txtCenter h-mrt60" style="margin-bottom:40px;">
                <div class="apprButton">
                    <el-row>
                        <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="cancel">返回</el-button>
                        <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgred el-button--default" @click="refuse">驳回</el-button>
                        <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="pass">通过</el-button>
                    </el-row>
                </div>
                <el-button v-if="!zstype"  @click="cancel" class="h-btn h-bBtn h-bgblueQ2">返回</el-button>
                <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
                <el-button v-if="!zstype"
                           size="small" class="h-btn h-bBtn h-bgblueQ2"
                           @click="genzongLiuch">
                    跟踪审批
                </el-button>
            </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                one : false,
                two : false,
                three : false,
                four : false,
                instid:null,
                formLabelAlign:{},
                zstype:false,
                flaag: true,
                showhistory:false,
                //合同名称
                HTName: [],
                //经销商名称
                AgentName: [],
                //table列表
                tableData: [],
                //表单
                f:{
                    id:null, //
                    contractId:null, // 返利合同id
                    agentName:null, // 经销商名称
                    agentCode:null, // 经销商编码
                    contractName:null, // 合同名称
                    areaCode:null, // 区域编码
                    area:null, // 区域
                    rebateBase:null, // 返利基数
                    rebateChainGroup:null, // 返利链群：样本网、药品网、其他、血液网、疫苗网、试剂网、液氮罐、合计
                    rebateSeries:null, // 返利系列：超低温产品、低温产品、恒温产品、生物安全产品、培养箱、其他产品、合计、U血液、U疫苗、U试剂、液氮罐
                    delflag:null, // 是否已经执行定时，1表示已执行定时，0表示未执行定时
                    organization:null, // 销售组织 乙方（海尔生物医疗股份有限公司，青岛海尔生物医疗科技有限公司）
                    rebateType:null, // 返利类型 传统ct、试剂网、血液网、疫苗网等
                    xiaoweiName:null, // 小微名称
                    xioweiCode:null, // 小微编码
                    qunianTongqi:null, // 去年同期
                    jinnianGoal:null, // 今年目标
                    salesVolume1:null, // 1月同期
                    salesVolume2:null, // 2月同期
                    salesVolume3:null, // 3月同期
                    salesVolume4:null, // 4月同期
                    salesVolume5:null, // 5月同期
                    salesVolume6:null, // 6月同期
                    salesVolume7:null, // 7月同期
                    salesVolume8:null, // 8月同期
                    salesVolume9:null, // 9月同期
                    salesVolume10:null, // 10月同期
                    salesVolume11:null, // 11月同期
                    salesVolume12:null, // 12月同期
                    goal1:null, // 1月目标
                    goal2:null, // 2月目标
                    goal3:null, // 3月目标
                    goal4:null, // 4月目标
                    goal5:null, // 5月目标
                    goal6:null, // 6月目标
                    goal7:null, // 7月目标
                    goal8:null, // 8月目标
                    goal9:null, // 9月目标
                    goal10:null, // 10月目标
                    goal11:null, // 11月目标
                    goal12:null, // 12月目标
                    year:null, // 年
                    statu:null, // 合同状态
                    contractStartTime:null, // 合同开始时间
                    contractEndTime:null, // 合同结束时间
                    instid:null, // 待办id
                    planStatus:null, // 计划状态：1，审核中；2，审核通过；3，审核拒绝
                    add1:null, //
                    add2:null, //
                    add3:null, //
                    agentType:null,
                },
                spform: {
                    optflag:null,
                    shpyj:null,
                },
                //产品list
                goalList: [],
                //表格
                multipleSelection: [],
            }
        },
        mounted() {
            this.query();
        },
        created() {
            this.query();
        },
        methods: {
            genzongLiuch(){
                this.showhistory = true;
            },
            query() {
                if(this.$route.query.taskstatus==0){
                    this.zstype=true;
                }
                this.instid = this.$route.query.instid;
                this.f.id = this.$route.query.ywid;
                //初始化获取计划数据
                var id=this.$route.query.ywid;
                var instid = this.$route.query.instid;
                var plan={"instid":instid,"planStatus":1};
                if(this.$route.query.taskstatus&&this.$route.query.taskstatus==1) {
                    //代办已审核的查看页
                    plan = {"id": this.$route.query.ywid};
                }
                ss.fanli.selectTargetXsjl(instid).then(rd => {
                    this.tableData = rd;
                    for(var i=0;i<this.tableData.length;i++){
                        var tar = this.tableData[i];
                        if(tar.rebateChainGroup == '传统合计' || tar.rebateChainGroup == 'cthj'){
                            var goal1 = tar.goal1+tar.goal2+tar.goal3;
                            var goal2 = tar.goal4+tar.goal5+tar.goal6;
                            var goal3 = tar.goal7+tar.goal8+tar.goal9;
                            var goal4 = tar.goal10+tar.goal11+tar.goal12;
                            var salesVolume1 = tar.salesVolume1+tar.salesVolume2+tar.salesVolume3;
                            var salesVolume2 = tar.salesVolume4+tar.salesVolume5+tar.salesVolume6;
                            var salesVolume3 = tar.salesVolume7+tar.salesVolume8+tar.salesVolume9;
                            var salesVolume4 = tar.salesVolume10+tar.salesVolume11+tar.salesVolume12;

                            if(goal1 < salesVolume1){
                                this.one = true;
                            }
                            if(goal2 < salesVolume2){
                                this.two = true;
                            }
                            if(goal3 < salesVolume3){
                                this.three = true;
                            }
                            if(goal4 < salesVolume4){
                                this.four = true;
                            }
                        }
                    }

                    this.f.agentCode =rd[0].agentCode;
                    this.f.agentName =rd[0].agentName;
                    this.f.agentType =rd[0].agentType;
                    this.f.year =rd[0].year;
                    this.f.organization =rd[0].organization;
                    this.f.area =rd[0].area;
                });
            },

            //取消提交
            cancel() {
                this.$router.back();
            },
            //通过按钮
            pass() {
                this.usercheck(2)
            },

            //驳回按钮
            refuse() {
                console.log(this.formLabelAlign.checkMsg,"sss");
                if(!this.formLabelAlign.checkMsg){
                    this.$msg.msge("请填写审批意见");
                }else{
                    this.usercheck(3)
                }
            },
            //返利合同审核
            usercheck(x) {
                this.formLabelAlign.id=this.$route.query.ywid;
                this.formLabelAlign.taskid=this.$route.query.taskid;
                this.formLabelAlign.planStatus=x;
                var msg = this.instid + "," + x+","+this.formLabelAlign.checkMsg;
                ss.fanli.checkFanliContractXsjl(msg).then(rd => {
                    this.$store.dispatch('searchTasktotal');
                    this.$msg.alerts("提交成功！",()=>{
                        this.$router.back();
                    })
                });
            },
        }
    }
</script>
<style scoped>
    .h-tableInput .el-input {
        height: 100%;
    }

    .anniu {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }

</style>
<style>
    .daoruhetong .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.8rem
    }

    .daoruhetong .h-formbLine .el-form-item__label {
        width: 40%;
    }

    .daoruhetong .h-formbLine .el-form-item__content {
        width: 60%;
    }
    .fltimeselect .el-date-editor.el-input__inner {
        width: 4rem;
    }

    .fltimeselect .el-form-item__content {
        line-height: 0.2rem;
    }

    .fltimeselect .el-date-editor .el-range-separator {
        width: 12%;
        line-height: 17px;
    }

    .fltimeselect .el-input__inner {
        padding-right: 0.1rem;
    }
	.gggg .h-formbLine .el-form-item__label {
	    width: 23%
	}

	.gggg .h-formbLine .el-form-item__content {
	    width: 77%
	}
</style>
<style>
    .sjwstyle .el-table thead.is-group th{
        background: #57aefe;
    }
</style>
